import React from 'react';
import { Header2, Header4 } from '@cian/ui-kit/typography';

import styles from './Title.css';

interface ITitleProps {
  title: string;
  subtitle?: string;
  isTop: boolean;
}

export const TitleComponent: React.FC<ITitleProps> = ({ title, subtitle, isTop }) => {
  return (
    <div className={styles['container']}>
      <Header2 data-mark="OfferTitle" color={isTop || subtitle !== undefined ? 'primary_100' : 'black_100'}>
        {title}
      </Header2>
      {subtitle && (
        <div className={styles['subtitle']}>
          <Header4 data-mark="OfferSubtitle">{subtitle}</Header4>
        </div>
      )}
    </div>
  );
};

TitleComponent.displayName = 'Title';

export const Title = React.memo(TitleComponent);
